import { cn } from "@/utils/utils";
import styles from "./style.module.css";

export default function ({
  animation,
  className
}: {
  animation?: boolean;
  className?: string;
}) {
  return (
    <div className={cn(styles.wrapper, "w-[60px] md:w-[180px]", className)}>
      <div
        className={cn(styles.loader, {
          [styles.animation]: animation
        })}
      ></div>
    </div>
  );
}
